import React, { useState, useEffect, useRef } from 'react';
import L from 'leaflet';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';

import '../pages/css/leafletStyles.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';

let DefaultIcon = L.icon({
            ...L.Icon.Default.prototype.options,
            iconUrl: icon,
            iconRetinaUrl: iconRetina,
            shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = DefaultIcon;

const MapItemSimple = ({ latitude, longitude, onAction }) => {
    const mapRef = useRef();  
    const markerRef = useRef();
    const [position, setPosition] = useState([latitude, longitude]);

    useEffect(() => {
        let lbounds = new L.LatLngBounds(L.latLng(90, -180), L.latLng(-90, 180));
        const map = mapRef.current.leafletElement;
        map.setMaxBounds(lbounds);

        setTimeout( () => {
            map.invalidateSize(true);     
        }, 800);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const updatePosition =  (event) => {
        const latLng = event.target.getLatLng();
        if (latLng) {
            setPosition(latLng)
            onAction(latLng);
        }
    }

    return (
        <Map
            center={[latitude, longitude]}
            zoom={13}
            scrollWheelZoom={false}
            ref = {mapRef}
            >
                <TileLayer
                    attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                    draggable={true}
                    position={position}
                    ref={markerRef}
                    onDragend = {updatePosition}>
                    <Popup minWidth={90}>
                        Your Location
                    </Popup>
                </Marker>
        </Map>
    )
};

export default MapItemSimple;